"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, useRef } from "react";
import GridColumn from "@/components/common/grid-column/grid-column";
const data = [{
  label: "In Loans Financed",
  value: "${stat} Billion",
  stat: 130
}, {
  label: "Clients Served",
  value: "{stat}+",
  stat: 730000
}, {
  label: "Lending Expertise",
  value: "{stat} Years",
  stat: 23
}];
const useInViewCustom = t0 => {
  const $ = _c(7);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  let t2;
  let t3;
  if ($[2] !== options) {
    t2 = () => {
      const element = ref.current;
      if (!element) {
        return;
      }
      const observer = new IntersectionObserver(t4 => {
        const [entry] = t4;
        if (entry.isIntersecting) {
          setInView(true);
          observer.unobserve(entry.target);
        }
      }, options);
      observer.observe(element);
      return () => observer.disconnect();
    };
    t3 = [options];
    $[2] = options;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== inView) {
    t4 = {
      ref,
      inView
    };
    $[5] = inView;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
const HomeStats = () => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      threshold: 0.3
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    ref,
    inView
  } = useInViewCustom(t0);
  const [counts, setCounts] = useState(_temp2);
  const easeOutCubic = _temp3;
  let t1;
  let t2;
  if ($[1] !== inView) {
    t1 = () => {
      if (!inView) {
        return;
      }
      const startTime = performance.now();
      const animate = now => {
        const elapsed = now - startTime;
        const progress = Math.min(1, elapsed / 1600);
        const eased = easeOutCubic(progress);
        setCounts(data.map(item_0 => Math.round(item_0.stat * eased)));
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          setCounts(data.map(_temp4));
        }
      };
      requestAnimationFrame(animate);
    };
    t2 = [inView];
    $[1] = inView;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== counts || $[5] !== ref) {
    t3 = data.map((item_2, index) => <GridColumn key={index} lg={4}><div ref={index === 0 ? ref : null} className="flex h-full w-full items-center"><div className="flex w-full flex-col items-center justify-center rounded-md bg-[#F6F6F6] px-3 py-9"><span className="whitespace-nowrap text-[2rem] font-semibold md:text-[2.375rem] xl:text-[2.75rem]">{item_2.value.replace("{stat}", counts[index].toLocaleString(undefined, {
              maximumFractionDigits: 0
            }))}</span><span className="text-xl font-medium">{item_2.label}</span></div></div></GridColumn>);
    $[4] = counts;
    $[5] = ref;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default HomeStats;
function _temp(item) {
  return item.stat;
}
function _temp2() {
  return data.map(_temp);
}
function _temp3(t) {
  return 1 - Math.pow(1 - t, 3);
}
function _temp4(item_1) {
  return item_1.stat;
}